import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Paper, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import WorkIcon from "@mui/icons-material/Work";

function WorkExperience() {
  const location = useLocation();
  const isPublicResultRoute = location.pathname.includes("/public-result");
  console.log("isPublicResultRoute-private-result", isPublicResultRoute);
  // Get data from appropriate reducer based on route
  const publicResult = useSelector(
    (state) => state?.ResultReducer?.publicResult || {}
  );
  const oldFormReducer = useSelector(
    (state) => state?.OldFormReducer || {}
  );

  // Determine which data source to use
  const resultData = isPublicResultRoute
    ? publicResult?.userData || publicResult || {}
    : oldFormReducer;

  const [userData, setUserData] = useState({
    workExperience: [],
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    // Get workExperience from the appropriate source
    const workExperienceData = isPublicResultRoute
      ? publicResult?.userData?.workExperience || publicResult?.workExperience || []
      : resultData?.workExperience || [];

    if (Array.isArray(workExperienceData) && workExperienceData.length > 0) {
      setUserData({
        workExperience: workExperienceData,
      });
    } else {
      setUserData({
        workExperience: [],
      });
    }
    setLoading(false);
  }, [resultData, publicResult, isPublicResultRoute]);
  return (
    <>
      <Box sx={{ px: { xs: 2, sm: 3, md: 10 } }}>
        <Grid item xs={12}>
          {userData?.workExperience && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  border: "1px solid #8DE49A",
                  borderRadius: "20px",
                  p: { xs: 3, sm: 3, md: 3, lg: 3 },
                  minWidth: { xs: "100%", md: "100%", lg: "70%" },
                  maxWidth: {
                    xs: "100%",
                    md: "100%",
                    lg: userData?.workExperience !== "" ? "100%" : "70%",
                  },
                }}
              >
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      mb: "32px",
                    }}
                  >
                    <div
                      style={{
                        width: "51px",
                        height: "51px",
                        backgroundColor: "#2bb344",
                        color: "#ffffff",
                        borderRadius: "30%",
                      }}
                    >
                      <WorkIcon
                        sx={{
                          width: { xs: "40px", md: "100%" },
                          height: "40px",
                          maxWidth: "51px",
                          alignSelf: "center",
                          marginTop: "5px",
                        }}
                        alt="WorkIcon"
                      />
                    </div>
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 600,
                        pl: { xs: 1, lg: 2 },
                        textAlign: "center",
                      }}
                    >
                      Work Experience
                    </Typography>
                  </Box>

                  {loading ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        py: 2,
                      }}
                    >
                      <CircularProgress color="primary" size={30} />
                    </Box>
                  ) : (
                    <Grid
                      container
                      sx={{
                        gap: 2,
                        justifyContent: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {userData?.workExperience?.map((exp, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={12}
                          lg={12}
                          xl={12}
                          key={index}
                        >
                          <Paper
                            sx={{
                              border: "1px solid #8DE49A",
                              borderRadius: "10px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              boxShadow: "none",
                              padding: "14px",
                            }}
                          >
                            {exp.role && (
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "18px",
                                  color: "rgb(15, 15, 13)",
                                }}
                              >
                                {exp.role}
                              </Typography>
                            )}
                            {exp.company && (
                              <Typography
                                sx={{
                                  color: "rgb(15, 15, 13)",
                                  fontSize: "14px",
                                }}
                              >
                                {exp.company}
                              </Typography>
                            )}
                            {exp.location && (
                              <Typography
                                sx={{
                                  fontStyle: "italic",
                                  fontSize: "14px",
                                  color: "rgb(15, 15, 13)",
                                }}
                              >
                                {exp.location}
                              </Typography>
                            )}
                            {exp.duration && (
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: "rgb(43, 179, 68)",
                                }}
                              >
                                {exp.duration}
                              </Typography>
                            )}
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Box>
          )}
        </Grid>
      </Box>
    </>
  );
}

export default WorkExperience;
